// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1lCeh","box":"WorkspacesBox_box__3Lziv","node":"WorkspacesBox_node__3BxKQ"};